import * as React from 'react';
import { observer } from "mobx-react";

import { DropdownView } from 'src/core/ui/dropdown.view';

interface DocumentTemplateEditorViewProps {
    docTemplateRequest: DropdownRequest<IDocumentTemplateSummary>;
	value: number;
    mode: ControlMode;
	onChanged: (value: IDocumentTemplateSummary) => void;
    label?: string;
    required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

@observer
export class DocumentTemplateEditorView extends React.Component<DocumentTemplateEditorViewProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        let label = this.props.label;
        if (label === undefined) {
            label = 'Template';
        }
        return (
            <DropdownView
                label={label}
                model={this.props.value}
                onGetErrorMessage={this.props.onGetErrorMessage}
                disabled={this.props.mode == 'display'}
                required={this.props.required}
                onChanged={(item) => { this.props.onChanged(item) }}
                request={this.props.docTemplateRequest}
                keyField='id'
                textField='displayName'
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/parts/document-template-editor.view.tsx